import { render, staticRenderFns } from "./google-2fa.vue?vue&type=template&id=5760bfca&scoped=true"
import script from "./google-2fa.vue?vue&type=script&lang=js"
export * from "./google-2fa.vue?vue&type=script&lang=js"
import style0 from "./google-2fa.vue?vue&type=style&index=0&id=5760bfca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5760bfca",
  null
  
)

export default component.exports